import { IonSpinner } from '@ionic/react';

import { UiTypography } from '@/components/ui/Typography';

import './LoaderLine.scss';

export const LoaderLine: React.FC<{
  label?: string;
}> = ({ label = 'Loading...' }) => {
  return (
    <UiTypography className="loader-line" variant="body-medium">
      {label}
      <IonSpinner name="circles" />
    </UiTypography>
  );
};
